import React from 'react';
import i18n from 'i18next';
import { Popup } from 'semantic-ui-react';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getTravelInsuranceList } from '../../redux/modules/insurances';
import { tableDateFormat } from '../../helpers/dates';
import formatCurrency from '../../helpers/formatCurrency';
import styles from './insuranceTable.module.scss';
import InsurancesTable from './InsurancesTable';
import { INSURANCE_TYPES } from '../../constants';

const TravelZone = (row, cell, prps, getSortArrow) => {
  const { property, title } = cell;
  const { handleSort, direction, column } = prps;
  const v = row[property];

  return (
    <div onClick={() => handleSort(property)} role="presentation">
      <span className={styles.expandTitle}>
        {i18n.t(title)}
        {getSortArrow(direction, column, property)}
      </span>
      <span className={styles.expandProperty}>
        {i18n.t(`travel.region.${v}.title`)}
        {i18n.t(`travel.region.${v}.description`)
          && (
          <Popup
            offset="0, 10px"
            position="top center"
            hideOnScroll
            content={i18n.t(`travel.region.${v}.description`)}
            trigger={(
              <div
                className={styles.infoIcon}
                role="button"
                aria-label="close"
                tabIndex="0"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
              />
            )}
          />
          )}
      </span>
      <span className={`${styles.expandProperty} ${styles.mobile}`}>
        {`${i18n.t(`travel.region.${v}.title`)} ${i18n.t(`travel.region.${v}.description`)}`}
      </span>
    </div>
  );
};

const TravelInsurancesTable = () => {
  const { t } = useTranslation();
  const { tblData, isLoading } = useSelector(
    (store) => store.insurances.travelInsuranceList, shallowEqual,
  );

  const columns = [
    {
      title: 'insuranceList.contractNumber',
      property: 'masysId',
      sortable: true,
    },
    {
      title: 'insuranceList.from',
      property: 'contractStart',
      sortable: true,
      format: tableDateFormat,
    },
    {
      title: 'insuranceList.to',
      property: 'contractEnd',
      sortable: true,
      format: tableDateFormat,
    },
    {
      title: 'insuranceList.zone',
      property: 'zone',
      sortable: true,
      customCell: (row, cell, prps, getSrt) => TravelZone(row, cell, prps, getSrt),
    },
    {
      title: 'insuranceList.price',
      property: 'price',
      sortable: true,
      format: (v) => `${formatCurrency(v)} ${t('currency.AMD')}`,
    },
  ];

  return (
    <InsurancesTable
      type={INSURANCE_TYPES.TRAVEL}
      title="insuranceList.travelInsurances"
      columns={columns}
      tblData={tblData}
      isLoading={isLoading}
      getInsuranceList={getTravelInsuranceList}
    />
  );
};

export default TravelInsurancesTable;
